import { render } from "./yanQuanScanBox.vue?vue&type=template&id=66c35dc5&scoped=true"
import script from "./yanQuanScanBox.vue?vue&type=script&lang=js"
export * from "./yanQuanScanBox.vue?vue&type=script&lang=js"

import "./yanQuanScanBox.vue?vue&type=style&index=0&id=66c35dc5&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c35dc5"]])

export default __exports__